import React from "react";
import "./NavbarSearch.scss";
import { AiOutlineSearch } from "react-icons/ai";
import { IoMdClose } from "react-icons/io";

export default function NavbarSearch() {
  return (
    <div className="navbar_search_container">
      <div className="searchbox_container">
        <AiOutlineSearch className="search_icon" />
        <input type="text" placeholder="Search for Qbank,Videos,Tests" />
        <IoMdClose className="close_icon" />
      </div>
    </div>
  );
}
